<!--
 * @Author: shiao
 * @Date: 2021-01-04 14:56:48
 * @LastEditTime: 2021-01-29 09:55:11
 * @Description: 酒店资质
 * @LastEditors: shiao
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\detail\qualificationinfo.vue
-->
<template>
  <div class="qualificationinfo-body">
    <div class="qualification-nav">
      <navbar
        title="商家资质"
        :lefticon="returnblackicon"
        :lefticonheight="1.5"
        :lefticonwidth="1.5"
        fontsize="1.6rem"
        :fontweight="500"
        navboxshadow=" 0rem 0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1)"
        @goback="goback"
      />
    </div>
    <div class="qualification-info-div">
      <div class="one-title">合作商家：</div>
      <div class="one-text">携程旅游信息技术（上海）有限公司</div>
      <div class="one-title">联系电话：</div>
      <div class="one-text">{{shopinfo.tel}}</div>
      <div class="one-title">邮箱地址：</div>
      <div class="one-text">{{shopinfo.email}}</div>
      <div class="one-title">商家资质：</div>
      <div class="qualification-img-div">
        <img :src="item" alt="" v-for="(item,index) in shopinfo.business_license" :key="index" @click="startPrewive(index)"/>
      </div>
    <imagepreview :previewshow="previewshow" :previewimages="shopinfo.business_license" :prewivewIndex="prewivewIndex"
      @closeImagePreview="closeImagePreview" />
    </div>
  </div>
</template>

<script>
import navbar from "../components/nav-bar.vue";
import imagepreview from "../components/image-preview.vue";
import { GethotelPlatforminfo } from "../api/index.js";
export default {
  components: {
    navbar,
    imagepreview
  },
  data() {
    return {
      returnblackicon: require("@/assets/hotel/img/micon/back_cb.png"),
      shopinfo:{},//商家信息
      previewshow:false,//图片预览
      prewivewIndex:0,//图片预览的起始位置
    };
  },
  created(){
       GethotelPlatforminfo().then(res=>{
      this.shopinfo = res
    })
  },
  methods: {
    //返回上一页
    goback() {
      this.$router.go(-1);
    },
    //开启图片预览
    startPrewive(index){
      this.previewshow = true
      this.prewivewIndex = index
    },
    //关闭图片预览
      closeImagePreview() {
        this.previewshow = false
      },
  },
};
</script>
<style >
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.qualification-nav {
  position: fixed;
  top: 0;
  padding-top: 4.4rem;
  width: 100%;
  z-index: 5;
  background-color: #fff;
}
.qualification-info-div {
  padding: 8.8rem 1.5rem 0;
  .one-title {
    height: 2.5rem;
    font-size: 1.8rem;
    font-weight: 500;
    color: #333333;
    line-height: 2.5rem;
    margin-top: 3.0rem;
  }
  .one-text {
    height: 2.2rem;
    font-size: 1.6rem;
    font-weight: 400;
    color: #333333;
    line-height: 2.2rem;
    margin-top: 1.5rem;
  }
  .qualification-img-div {
    margin-top: 1.5rem;
    max-height: 52.6rem;
    width: 100%;
    padding-bottom: 2.0rem;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
